import * as toolkitRaw from '@reduxjs/toolkit';
import DrupalActions from '../actions/drupal-actions';

const { configureStore } = toolkitRaw

export default configureStore({
    reducer : {
        drupal : DrupalActions
    }
})